import React from 'react';
import { InputHelper } from "../../../../helpers";
import StandardTextFormEditorComponent from "../../../basics/form/StandardTextFormEditorComponent";
import FormattedMessageString from "../../../basics/FormattedMessageString";
import AdditionalFieldFormError from "../errors/AdditionalFieldFormError";

class AdditionalFieldTextFormComponent {
    static fields(settings) {
        let fields = [{
            type: "col",
            md: 12,
            fields: [
                {
                    title: "CMS.Modules.AdditionalField.Content.Form.field_key",
                    type: "text",
                    name: 'field_key',
                    disabled: !!settings.isEdit,
                    message: "CMS.Modules.AdditionalField.Content.Form.field_key.message",
                    customFeedback: AdditionalFieldFormError,
                    formErrorName: "field_key",
                    beforeOnChange: (e) => InputHelper.transformToLowerCaseAndUnderscore(e.target.value),
                }
            ]
        },
        {
            type: "col",
            md: 12,
            fields: [
                {
                    title: "CMS.Modules.AdditionalField.Content.Form.field_type",
                    type: "select",
                    name: 'field_type',
                    disabled: !!settings.isEdit,
                    options: [
                        { value: 'text', label: 'Tekstveld' },
                        { value: 'textarea', label: 'Groot tekstveld' },
                        { value: 'numeric', label: 'Numeriek veld' },
                        { value: 'url', label: 'URL veld' },
                        { value: 'editor', label: 'Teksteditor' },
                        { value: 'select', label: 'Selectieveld' }
                    ],
                    customFeedback: AdditionalFieldFormError,
                    formErrorName: "field_type",
                    beforeOnChange: (e, _) => settings.onChange('type', e.value)
                }
            ]
        },
        {
            type: "col",
            md: 12,
            fields: [
                {
                    title: "CMS.Modules.AdditionalField.Content.Form.label",
                    type: "text",
                    name: 'label',
                    customFeedback: AdditionalFieldFormError,
                    formErrorName: 'label',
                    // disabled: !settings.isWizard
                }
            ]
        },
        {
            type: "col",
            md: 12,
            fields: [
                {
                    title: "CMS.Modules.AdditionalField.Content.Form.help_text",
                    type: "text",
                    name: 'help_text',
                    message: "CMS.Modules.AdditionalField.Content.Form.help_text.message",
                    customFeedback: AdditionalFieldFormError,
                    formErrorName: 'help_text',
                    disabled: !settings.isWizard
                }
            ]
        },
        {
            type: "col",
            md: 12,
            fields: [/*
                {
                    title: "CMS.Modules.AdditionalField.Content.Form.extra_info_website",
                    type: "text",
                    name: 'extra_info_website',
                    message: "CMS.Modules.AdditionalField.Content.Form.extra_info_website.message",
                    customFeedback: AdditionalFieldFormError,
                    formErrorName: 'extra_info_website',
                    custom: StandardTextFormEditorComponent,
                    customProps: { valueField: 'extra_info_website' }
                }
           */],

            custom: StandardTextFormEditorComponent,
            customProps: { valueField: 'extra_info_website', label: 'CMS.Modules.AdditionalField.Content.Form.extra_info_website', placeholder: 'CMS.Modules.AdditionalField.Content.Form.extra_info_website.placeholder' }
        },
        {
            type: "col",
            md: 12,
            fields: [{
                title: "CMS.Modules.AdditionalField.Content.Form.active",
                type: "switch",
                name: 'active',
                customFeedback: AdditionalFieldFormError,
                formErrorName: "active"
            }],
            messageId: "CMS.Modules.AdditionalField.Content.Form.active.message"
        },
        {
            type: "col",
            md: 12,
            fields: [{
                title: "CMS.Modules.AdditionalField.Content.Form.is_required",
                type: "switch",
                name: 'is_required',
                customFeedback: AdditionalFieldFormError,
                formErrorName: "is_required",
                disabled: !settings.isWizard
            }]
        }];

        if (['text', 'numeric'].indexOf(settings.type) > -1) {
            fields.push({
                type: "col",
                md: 12,
                fields: [{
                    title: "CMS.Modules.AdditionalField.Content.Form.has_prefix_choices",
                    type: "switch",
                    name: 'has_prefix_choices',
                    customFeedback: AdditionalFieldFormError,
                    formErrorName: "has_prefix_choices",
                    disabled: !settings.isWizard,
                    beforeOnChange: (e, _) => settings.onChange('has_prefix_choices', !settings.has_prefix_choices)
                }]
            });
            if (settings.has_prefix_choices) {
                fields.push({
                    type: "col",
                    md: 12,
                    fields: [
                        {
                            title: "CMS.Modules.AdditionalField.Content.Form.prefix_choices",
                            type: "text",
                            name: 'prefix_choices',
                            customFeedback: AdditionalFieldFormError,
                            formErrorName: 'prefix_choices'
                        }
                    ]
                });
            }

            fields.push({
                type: "col",
                md: 12,
                fields: [{
                    title: "CMS.Modules.AdditionalField.Content.Form.has_suffix_choices",
                    type: "switch",
                    name: 'has_suffix_choices',
                    customFeedback: AdditionalFieldFormError,
                    formErrorName: "has_suffix_choices",
                    disabled: !settings.isWizard,
                    beforeOnChange: (e, _) => settings.onChange('has_suffix_choices', !settings.has_suffix_choices)
                }]
            });
            if (settings.has_suffix_choices) {
                fields.push({
                    type: "col",
                    md: 12,
                    fields: [
                        {
                            title: "CMS.Modules.AdditionalField.Content.Form.suffix_choices",
                            type: "text",
                            name: 'suffix_choices',
                            customFeedback: AdditionalFieldFormError,
                            formErrorName: 'suffix_choices'
                        }
                    ]
                });
            }
        }

        if (['url'].indexOf(settings.type) > -1) {
            fields.push({
                type: "col",
                md: 12,
                fields: [
                    {
                        title: "CMS.Modules.AdditionalField.Content.Form.url_link_text",
                        type: "text",
                        name: 'url_link_text',
                        customFeedback: AdditionalFieldFormError,
                        formErrorName: 'url_link_text'
                    }
                ]
            });
            fields.push({
                type: "col",
                md: 12,
                fields: [
                    {
                        title: "CMS.Modules.AdditionalField.Content.Form.url_target",
                        type: "select",
                        options: ['_self', '_blank'].map(item => { return { value: item, label: <FormattedMessageString id={'CMS.Modules.AdditionalField.Content.Form.url_target.' + item} /> } }),
                        name: 'url_target',
                        customFeedback: AdditionalFieldFormError,
                        formErrorName: 'url_target'
                    }
                ]
            });
        }

        return [{
            type: "row",
            children: fields
        }];
    }

    static async fields_image_before_submit(element) {
        return new Promise(async (resolve, reject) => {
            let item = element.state.model;

            element.setState({ model: item }, () => resolve(true))
        })
    }
}

export default AdditionalFieldTextFormComponent;